// opervex-frontend/src/pages/HumanResources/Integrations.js

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Form, Card, Button } from "react-bootstrap";
import { FaSave } from "react-icons/fa";

import { useAuth } from "../../contexts/AuthContext";
import useOpervex from "../../hooks/useOpervex";
import ConfirmService from "../../components/ConfirmationModal/ConfirmService";

import "./integration.css";

const rolePageRequire = "HR_INTEGRATION";

var dataDefault = {
  simulation: true,
  sector: false,
  role: false,
  employee: false,
  timeTracking: false,
  startDate: null,
  endDate: null,
  messages: "",
};

const Integrations = () => {
  const { roles, loadingGlobal } = useAuth();
  const [data, setData] = useState(dataDefault);
  const [actionRun, setActionRun] = useState(false);
  const { id } = useParams();
  const OpervexAPI = useOpervex();

  useEffect(() => {
    const fetchData = async () => {
      commandAction();
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loadingGlobal) {
    return <div>Carregando...</div>;
  }

  const commandAction = () => {
    const hasPermission = roles.find((role) => role.command === rolePageRequire);

    if (!hasPermission) {
      setActionRun(false);
      return;
    }

    setActionRun(!hasPermission.actions.some((action) => action.key === "Read"));
  };

  const handleButtonRun = async () => {
    var body = {
      options: {
        sector: data.sector,
        role: data.role,
        employee: data.employee,
        timeTracking: data.timeTracking,
      },
      parameters: {
        simulation: data.simulation,
        startDate: data.startDate,
        endDate: data.endDate,
      },
    };

    setActionRun(true);
    setData({ ...data, messages: "⚠️ Executando integração" });

    const result = await OpervexAPI.HumanResources.Integrations.synchronize(body);

    setActionRun(false);

    if (result.errors) {
      await ConfirmService.show("Aviso", result.errors, true);
      return;
    }

    if (result && Array.isArray(result)) {
      var message = "";

      result.forEach((item) => {
        message += `<span class="badge log ${item.type}">[${item.timeStamp}] ${item.message}</span></br>`;
      });

      message = `<div class="log-line">${message}</div>`;
    }

    setData({ ...data, messages: message });
  };

  const handleChange = async (e) => {
    const { name, value, type, checked } = e.target;

    var _value = value;
    var newData = { ...data };

    if (name === "timeTracking") {
      if (checked) {
        newData.startDate = new Date().toISOString().split("T")[0];
        newData.endDate = new Date().toISOString().split("T")[0];
      } else {
        newData.startDate = null;
        newData.endDate = null;
      }
    }

    newData = {
      ...newData,
      [name]: type === "checkbox" ? checked : _value,
    };

    setData(newData);
  };

  return (
    <>
      <Container className="mt-2">
        <Form>
          {/* ----- Header / Additional -----*/}
          <Card className="mb-2">
            <Card.Header>
              <Row className="d-flex justify-content-between">
                <Col md={8}>
                  <h5>Integrações</h5>
                </Col>
                <Col md={4} className="text-end">
                  <Button variant="primary" size="sm" className="me-2" onClick={handleButtonRun} disabled={actionRun}>
                    <FaSave /> Executar
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <Row className="mb-2">
                <Col md={10}>
                  <Form.Check
                    type="checkbox"
                    id="sector"
                    checked={data.sector}
                    name="sector"
                    onChange={handleChange}
                    label="Setores"
                  />
                  <Form.Check type="checkbox" id="role" checked={data.role} name="role" onChange={handleChange} label="Cargos" />
                  <Form.Check
                    type="checkbox"
                    id="employee"
                    checked={data.employee}
                    name="employee"
                    onChange={handleChange}
                    label="Funcionários"
                  />
                  <Form.Check
                    type="checkbox"
                    id="timeTracking"
                    checked={data.timeTracking}
                    name="timeTracking"
                    onChange={handleChange}
                    label="Registro Ponto"
                  />
                </Col>
                <Col md={2}>
                  <Form.Check
                    type="checkbox"
                    id="simulation"
                    checked={data.simulation}
                    name="simulation"
                    onChange={handleChange}
                    label="Modo Simulação"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
          {/* ----- Filters -----*/}
          <Card className="mb-2">
            <Card.Header>
              <h5>Filtros</h5>
            </Card.Header>
            <Card.Body>
              <Row className="mb-2">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Data de Início</Form.Label>
                    <Form.Control
                      type="date"
                      id="startDate"
                      name="startDate"
                      size="sm"
                      value={data.startDate || ""}
                      onChange={handleChange}
                      disabled={!data.timeTracking}
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Data de Fim</Form.Label>
                    <Form.Control
                      type="date"
                      id="endDate"
                      name="endDate"
                      size="sm"
                      value={data.endDate || ""}
                      onChange={handleChange}
                      disabled={!data.timeTracking}
                    />
                  </Form.Group>
                </Col>
                <Col md={8}></Col>
              </Row>
            </Card.Body>
          </Card>

          {/* ----- Log -----*/}
          <Card className="mb-2">
            <Card.Header>
              <h5>Logs</h5>
            </Card.Header>
            <Card.Body>
              <Row className="mb-2">
                <Col md={12}>
                  <div dangerouslySetInnerHTML={{ __html: data.messages }} />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Form>
      </Container>
    </>
  );
};

export default Integrations;
